import { RootState } from '../../../store';

export const getAppSettings = (state: RootState) => state.settings.app;
export const getOrganization = (state: RootState) => state.settings.organization;
export const getSettingsUi = (state: RootState) => state.settings.ui;
export const getPricelistMailSettings = (state: RootState) => state.settings.pricelistMailing;
export const getApplicationRestrictions = (state: RootState) => state.settings.applicationRestrictions;
